import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { map, Subscription } from 'rxjs';
import isRequired from '../../helpers/decorator';
import { LookupBase } from '../../models/lookup.base.model';
import { LookupService } from '../../services/lookup.service';

@Component({
  selector: 'app-drop-down-multi-select',
  templateUrl: './drop-down-multi-select.component.html',
  styleUrls: ['./drop-down-multi-select.component.css']
})
export class DropDownMultiSelectComponent implements OnInit {
  @Output() onMultiSelectdataChange: EventEmitter<any> = new EventEmitter();
  @Input() skipCaching: boolean;
  @Output() onFinished: EventEmitter<any> = new EventEmitter();
  @Input() dropDownList: Array<{ id: any, name: any }> = [];
  @Input() url: string;
  @isRequired()
  @Input() fg: FormGroup;
  @isRequired()
  @Input() fcn: string;
  @Input() isDisabled: boolean;
  subscription: Subscription;
  dropdownSettings: IDropdownSettings = {
    searchPlaceholderText:this.translate.instant('common.search'),
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: this.translate.instant('lookups.selectAll'),
    unSelectAllText:  this.translate.instant('lookups.deselectAll'),
    allowSearchFilter: true,
    // isDisabled:true
  };
  constructor(private lookupService: LookupService, private translate: TranslateService,
  ) { }
  ngOnInit() {
    if (this.url) {
      this.fetchUrl();
    }
    this.observe();
  }
  fetchUrl() {
    this.lookupService.getLookup(this.url)
      .pipe(map((res): Array<LookupBase> => {
        !this.skipCaching && this.lookupService.saveLookup(this.url, res)
        return (res.value).map((obj) => {
          return {
            id: obj.id,
            name: obj.name
          }
        })
      }))
      .subscribe(_res => {
        this.dropDownList = _res as Array<LookupBase>
      })
  }
  observe() {
    this.subscription = this.fg.get(this.fcn).valueChanges
      .subscribe(_res => {
        this.fg.get(this.fcn).updateValueAndValidity({ emitEvent: false });
      })
  }

  map(data: Array<any>) {
    return data.map(e => {
      return {
        id: e.id,
        itemName: e.value
      }
    })
  }
  onItemDeSelect(event) {
    this.onMultiSelectdataChange.emit(this.fg.get(this.fcn).value);
  }
  onItemSelect(event) {
    this.onMultiSelectdataChange.emit(this.fg.get(this.fcn).value);
  }
  onSelectAll(event) {
    this.onMultiSelectdataChange.emit(event);
  }
  onDeSelectAll(event) {
    this.onMultiSelectdataChange.emit(event);
  }
  ngOnDestroy() {
  }

}
